function Features({ features }) {
  return (
    <div className="flex flex-wrap justify-center">
      {features.map((feature) => (
        <div className="bg-slate-50 h-56 w-full sm:w-3/4 md:w-1/2 lg:w-60 rounded-xl mb-6 px-2 py-3 shadow-xl">
          <img
            src={feature.icon}
            alt={feature.name}
            className="w-8 h-8 m-2"
          />
          <span className="font-sans text-lg font-bold">{feature.name}</span>
          <div className="text-black mt-2 text-sm font-sans">
            {feature.description}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Features;

